import cx from 'classnames';
import styles from './styles.module.scss';
import vector from '../../assets/images/vector.jpg';
import Button from '../../components/Button';
import { CycleIcon, UploadV2Icon, UnlockIcon } from '../../assets/icons';
import { ALLOW_CATEGORY_UPLOAD } from './useCategoryActions';
import { useUserContext } from '../../contexts/UserContext';
import { useCallback, useState } from 'react';
import { setConfiguratorRequestFormOpen } from '../../redux/slicers/appSlicer';
import { setRequestVideoDialogOpen } from '../../redux/slicers/admin/curatorSlicer';
import { useDispatch } from 'react-redux';
import AddConfigurator from './AddConfigurator';
import { setShowUpgradeMorePopup } from '../../redux/slicers/productV2Slicer';
import { warningToast } from '../../helpers/toastHelper';
import { getProductPageType } from '../../helpers/jsHelper';
import { Mixpanel, MxEvent } from '../../common/Mixpanel';

export const NoContent = ({
  category,
  handleUpload = null,
  data,
  className = 'h-100',
  title = <>There&apos;s nothing here</>,
  description = 'Start creating to add to your presentation',
  hideActions = false,
  showTitleAndDescription = true,
  refetch,
  eventProperties = {},
}) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { isFreemiumUser, isGuestUser, isEditor } = useUserContext();

  const getBtnTitle = () => {
    if (category === getProductPageType().CONFIGURATOR) {
      return isGuestUser() ? 'Add Configurator' : 'Request Configurator';
    }
    if (category === getProductPageType().VIDEO) {
      return isGuestUser() ? null : 'Request Video';
    }
    // TODO: Make it unhide when work on it
    // if (category === getProductPageType().ARVIEWER) {
    //   return 'Unlock AR';
    // }
    // return 'Generate Visuals';
    return null; // TODO: Make it unhide when work on it
  };

  const getBtnIcon = () => {
    if (category === getProductPageType().CONFIGURATOR) {
      return null;
    }
    if (category === getProductPageType().VIDEO) {
      return null;
    }
    if (category === getProductPageType().ARVIEWER) {
      return <UnlockIcon />;
    }
    return <CycleIcon />;
  };

  const handleClick = useCallback(() => {
    if (category === getProductPageType().CONFIGURATOR) {
      Mixpanel.track(true, MxEvent.CTA_CLICKED, {
        cta_type: isGuestUser() ? 'Add Configurator' : 'Request Configurator',
        ...eventProperties,
      });
      isGuestUser() ? setShow(true) : dispatch(setConfiguratorRequestFormOpen(true));
    } else if (category === getProductPageType().VIDEO) {
      Mixpanel.track(true, MxEvent.CTA_CLICKED, {
        cta_type: 'Request Video',
        ...eventProperties,
      });
      dispatch(setRequestVideoDialogOpen(true));
    } else if (category === getProductPageType().ARVIEWER) {
      // TODO: Implement the working of this button
    }
  }, [category]);

  const btnDisabled = () => {
    return isGuestUser() && !isEditor;
  };

  const onUpload = () => {
    if (!isGuestUser() && isFreemiumUser()) {
      dispatch(setShowUpgradeMorePopup(true));
      return;
    }
    if (isGuestUser() && !isEditor) {
      warningToast('Permission denied');
      return;
    }
    handleUpload?.(data);
  };

  return (
    <>
      <div
        className={cx(
          'w-100 d-flex justify-content-center align-items-center',
          className,
          styles.noContentContainer
        )}>
        <div
          className={`d-flex flex-column justify-content-center align-items-center ${styles.noContentParent}`}>
          <div
            className={`w-auto h-auto d-flex justify-content-center align-items-center ${styles.gap10}`}>
            <div
              className={`${styles.noContentImageBlockSmall} d-flex justify-content-center align-items-center`}>
              <img src={vector} alt="image" height="15px" width="15px" />
            </div>
            <div
              className={`${styles.noContentImageBlockBig} d-flex justify-content-center align-items-center`}>
              <img src={vector} alt="image" height="34px" width="34px" />
            </div>
            <div
              className={`${styles.noContentImageBlockSmall} d-flex justify-content-center align-items-center`}>
              <img src={vector} alt="image" height="15px" width="15px" />
            </div>
          </div>
          {showTitleAndDescription && (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{ gap: '4px', padding: '8px 0px' }}>
              <h5 className={`${styles.noContentText1} mb-0`}>{title}</h5>
              <h5 className={`${styles.noContentText2} mb-0`}>{description}</h5>
            </div>
          )}
          {!hideActions && (
            <div className="w-auto h-auto d-flex" style={{ gap: '4px' }}>
              {getBtnTitle() && (
                <Button
                  onClick={handleClick}
                  color="dark"
                  size="sm"
                  className={`${styles.bigBtn} d-flex`}
                  disabled={btnDisabled()}
                  iconBefore={getBtnIcon()}>
                  {getBtnTitle()}
                </Button>
              )}
              {ALLOW_CATEGORY_UPLOAD.includes(category) && handleUpload && (
                <Button
                  onClick={() => {
                    Mixpanel.track(true, MxEvent.CTA_CLICKED, {
                      cta_type: 'Upload',
                      ...eventProperties,
                    });

                    onUpload();
                  }}
                  color="dark"
                  size="sm"
                  className={`${styles.bigBtn} d-flex`}
                  iconBefore={<UploadV2Icon />}>
                  Upload Content
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
      {show && <AddConfigurator data={data} refetch={refetch} show={true} setShow={setShow} />}
    </>
  );
};
